import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import classNames from 'classnames'
import FICColors from '../../../common/styles/FICColors'

const prefixMapping = {
  solid: 'fas',
  regular: 'far',
  light: 'fal',
  brand: 'fab',
  duotone: 'fad'
}

// TODO: dove vengono usati style, className e onClick? Li lasciamo?

const FICIconImpl = ({ name, type, className, spin, fixedWidth, style, domProps, onClick, ...iconProps }) => {
  const prefix = prefixMapping[ type ]
  if (spin) { name = 'circle-notch' }

  const classes = [
    'Icon',
    prefix,
    'fa-' + name,
    spin ? 'fa-spin' : undefined,
    fixedWidth ? 'fa-fw' : undefined,
    className
  ]
  return <b
    className={classNames(classes)}
    style={style}
    onClick={onClick}
    {...domProps}
    {...iconProps}
  />
}

const FICIcon = styled(FICIconImpl)`
  color: ${props => FICColors[ props.color ] || props.color || undefined};
  font-size: ${props => props.size ? (props.size + 'px') : undefined};
`

FICIcon.propTypes = FICIconImpl.propTypes = {
  type: PropTypes.oneOf([ 'solid', 'regular', 'light', 'brand', 'duotone' ]),
  /** According to font-awensome set the name */
  name: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  /** Set true to enable spin */
  spin: PropTypes.bool,
  fixedWidth: PropTypes.bool,
  domProps: PropTypes.object,
  onClick: PropTypes.func,
  /** Set the color of the icon */
  color: PropTypes.string,
  /** Set the size in px */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

FICIcon.defaultProps = FICIconImpl.defaultProps = {
  type: 'regular',
  name: '',
  className: '',
  style: {},
  spin: false,
  fixedWidth: false,
  domProps: {},
  onClick: undefined,
  color: undefined,
  size: undefined
}

export const SolidIcon = props => <FICIcon type='solid' {...props} />

export const RegularIcon = props => <FICIcon type='regular' {...props} />

export const LightIcon = props => <FICIcon type='light' {...props} />

export const BrandIcon = props => <FICIcon type='brand' {...props} />

export default FICIcon



// WEBPACK FOOTER //
// ./src/common/components-v2/FICIcon/FICIcon.js